import config from '../../config/config';

import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

export default {
  /**
   * Get the profile details in api function
   * @returns
   */
  getProfileDetails: (): Promise<any> => {
    return getRequest(`${config.accountApiUrl}api/facility/v1/users/profile`);
  },
  /**
   * Get the total charging station function
   * @returns
   */
  getTotalChargingStation: (): Promise<any> => {
    return getRequest(
      `${config.commonApiUrl}api/facility/v1/charging-station/total-charging-stations`,
    );
  },
  /**
   * Get the total charging station function
   * @returns
   */
  getTotalChargingPoints: (): Promise<any> => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/charging-point/total-charging-points`);
  },
  /**
   * Get the total charging station function
   * @returns
   */
  getTotalConnectors: (): Promise<any> => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/charging-point/total-connectors`);
  },
  /**
   * Get revenue history
   */
  getRevenueHistory: (): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/facility/v1/charging-transaction/cs-revenue-growth-month-wise`,
    );
  },
  /**
   * Get total balance
   */
  getTotalWalletBalance: (): Promise<any> => {
    return getRequest(`${config.reportApiUrl}api/facility/v1/charging-transaction/total-revenue`);
  },
    /**
   * Create the role api call function
   * @param data
   * @returns
   */
createPayout: (data: any): Promise<any> => {
  const parameters = { ...data };
  return postRequest(
    `${config.accountApiUrl}api/facility/v1/account/create-stripe`,
    { ...parameters }
  );
},
  /**
   * Get the get Stripe Settings
   * @returns
   */
  getStripeSettings: (): Promise<any> => {
    return getRequest(`${config.accountApiUrl}api/facility/v1/account/get-stripe-settings`);
  },
     /**
   * Update the update Payout
   * @param data
   * @returns
   */
  updatePayout: (data: any): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(`${config.accountApiUrl}api/facility/v1/account/update-payout-preference`, {
      ...parameters,
    });
  },
       /**
   * Update the update Payout Enabled
   * @param data
   * @returns
   */
  updatePayoutEnabled: (data: any): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(`${config.accountApiUrl}api/facility/v1/account/update-payout-ability`, {
      ...parameters,
    });
  },
 
};
